var map = {
	"./article@3x.png": 2742,
	"./brandasset@3x.png": 978,
	"./campaign@3x.png": 3904,
	"./industryevent@3x.png": 7687,
	"./product@3x.png": 4842,
	"./science@3x.png": 3229,
	"./searchIcon@3x.png": 7426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9658;